module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAPCAYAAADQ4S5JAAAAAXNSR0IArs4c6QAAAPtJREFUKFOlkj0vRUEQhp85pU7UEj9AoiOIXvwGnZxZoZEoiFwRoVAqRLKzpY7/4atT6kSnUtBJdlhBjuPcewtT7syT953ZV1R1E9gARvlbb8CWmdl3S1T1UUQecs6XzfmqqubcfQF4cff1lNJZ6RfgVUSOYoyHTUBVT4Al4B6YB1bM7GIYsFiUcs7nwKSIrA4DlkXkGhhx96LyNAjYcfdi6bNEZAwY7wu0DxZC6Ln79i8ghLAPzLSGb2KMe52AqgZgtgVcmVnsBDo+7uepE6jrek1Eppvgx+K3KaXTfpZ2gamW0p2ZHfzLUmeW2vt8ZWuinHVQWpvcM3D8DlqGr5o87E9WAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/menus_icon/nrgl.png
// module id = DFsl
// module chunks = 3